import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const CalendarIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.33533 9.16675H10.6687M5.33533 9.16675H5.34131M8.66866 11.8334H5.33533M10.6687 11.8334H10.6627"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.002 1.83325V3.16659M4.00195 1.83325V3.16659"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66858 8.66213C1.66858 5.75729 1.66858 4.30485 2.50333 3.40243C3.33807 2.5 4.68157 2.5 7.36858 2.5H8.63525C11.3222 2.5 12.6658 2.5 13.5005 3.40243C14.3352 4.30485 14.3352 5.75729 14.3352 8.66213V9.00453C14.3352 11.9094 14.3352 13.3618 13.5005 14.2643C12.6658 15.1667 11.3222 15.1667 8.63525 15.1667H7.36858C4.68157 15.1667 3.33807 15.1667 2.50333 14.2643C1.66858 13.3618 1.66858 11.9094 1.66858 9.00453V8.66213Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.00195 5.83325H14.002"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
